import { LifecycleEvent } from 'apprise-core/common'
import { User, userLifecycleTopic } from 'apprise-core/user'
import { EventSubscription } from "apprise-frontend-events/subscriptions"
import { useLogged, useLogin } from 'apprise-frontend-iam/login/logged'
import { useCurrentLocation } from 'apprise-ui/link/currentlocation'
import { useHistory } from 'react-router-dom'
import { userLogoutTopic } from "./constants"
import { useUserStore } from './store'

export type UserLogoutEvent = {
    users: string[]
}

export const useUserLogoutListener = (): EventSubscription<UserLogoutEvent> => {

    const logged = useLogged()
    const login = useLogin()

    return {

        topic: userLogoutTopic

        ,

        onEvent: (event: UserLogoutEvent) => event.users.includes(logged.username) && login.logout({ askConsent: true })

    }
}


export type UserChangeEvent = {
    user: User
    type: 'add' | 'remove' | 'change'
}

const isFirstGen = (event:UserChangeEvent | LifecycleEvent<User>) : event is UserChangeEvent => !!(event as UserChangeEvent).user

// supports first generation or second generation publishers.
export const useUserChangeListener = (): EventSubscription<UserChangeEvent | LifecycleEvent<User>> => {

    const userstore = useUserStore()

    const location = useCurrentLocation()

    const history = useHistory()

    const login = useLogin()
   
    return {

        topic: userLifecycleTopic

        ,

        onEvent: (e: UserChangeEvent | LifecycleEvent<User>) => {

            const event: UserChangeEvent = isFirstGen(e) ? e : { ...e, user: e.subject} 

            userstore.push(event)

            if (login.logged().username === event.user.username)
                login.setLogged(event.user)


            history.replace(location.current(), `${event.user.username}-${event.type}`)
                

        }

    }

}